import { render, staticRenderFns } from "./PosDiscount.vue?vue&type=template&id=7cce53c2&scoped=true&"
import script from "./PosDiscount.vue?vue&type=script&lang=js&"
export * from "./PosDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cce53c2",
  null
  
)

export default component.exports